import { API } from "api/axios.config";

const BASE_URL = "InterestCalculator";

export const getInterestCalculation = async (params) => {
  return (await API.get(`/${BASE_URL}/`, { params })).data?.data;
};

export const getActiveInterestSchemes = async () => {
  return (await API.get(`/${BASE_URL}/Schemes`, { params: { active: true } }))
    .data?.data; // Service handles the data extraction
};



export const addInterestScheme = async (apiPayload) => {
  return await API.post(`/${BASE_URL}/Schemes`, JSON.stringify({ data: apiPayload }), {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateInterestScheme = async (id, apiPayload) => {
  return await API.patch(`/${BASE_URL}/Schemes/${id}`, JSON.stringify({ data: apiPayload }), {
    headers: { "Content-Type": "application/json" },
  });
};